import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import UserContext from "../contexts/UserContext";

/**
 * Render the navbar at the top of the screen
 * @returns the navbar
 */
const Navbar = () => {
  const userContext = useContext(UserContext);
  const location = useLocation();
  const [open, setOpen] = useState(false); // whether the user has click on the 3 lines in mobile view

  // all of the possible links
  const links = [
    { name: "Home", to: "/", current: location.pathname === "/" },
    {
      name: "Iron Sights",
      to: "/iron-sights",
      current: location.pathname === "/iron-sights",
    },
    { name: "Duels", to: "/duels", current: location.pathname === "/duels" },
    {
      name: "Leaderboards",
      to: "/leaderboards",
      current: location.pathname === "/data",
    },
    { name: "Data", to: "/data", current: location.pathname === "/data" },
    {
      name: "Settings",
      to: "/settings",
      current: location.pathname === "/settings",
    },
  ];

  return (
    <nav className="bg-gray-900">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-16">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
              onClick={() => setOpen((cur) => !cur)}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className="hidden h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
            <div className="hidden sm:block md:ml-6">
              <div className="flex space-x-1 md:space-x-4">
                {links.map((link) => (
                  <Link
                    key={link.name}
                    to={link.to}
                    className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <button
              type="button"
              className="bg-indigo-500 py-1 px-3 rounded-lg font-bold text-gray-900 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            >
              {userContext.loggedIn ? (
                <Link
                  to={"/" + (Math.random() < 0.5 ? "iron-sights" : "duels")}
                >
                  Play
                </Link>
              ) : (
                <Link to="/login">Login</Link>
              )}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="sm:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.to}
                className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
